import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {FilterStateEngine} from '../../filter-state-engine';
import {
    SearchFilterDefinition,
    SearchFilterSelection,
    SearchFilterSelectionValue,
    SearchFilterValue,
    SearchFilterViewModel,
} from '../../filter-state.models';

@Component({
    selector: 'app-cascading-filter-bar',
    templateUrl: './cascading-filter-bar.component.html',
    standalone: false,
})
export class CascadingFilterBarComponent implements OnChanges {
    @Input() public definitions: readonly SearchFilterDefinition<SearchFilterValue>[] = [];
    @Input() public initialSelection: SearchFilterSelection<SearchFilterValue> = {};
    @Output() public selectionChange = new EventEmitter<SearchFilterSelection<SearchFilterValue>>();

    public viewModels: SearchFilterViewModel<SearchFilterValue>[] = [];
    private selection: SearchFilterSelection<SearchFilterValue> = {};
    private engine = new FilterStateEngine<SearchFilterValue>([]);

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['definitions'] || changes['initialSelection']) {
            this.engine = new FilterStateEngine(this.definitions);
            this.selection = {...this.initialSelection};
            this.refreshViewModels();
        }
    }

    public onSelectionChanged(key: string, value: SearchFilterSelectionValue<SearchFilterValue>): void {
        this.selection = this.engine.select(this.selection, key, value);
        this.refreshViewModels();
        this.selectionChange.emit({...this.selection});
    }

    public isChecked(value: SearchFilterSelectionValue<SearchFilterValue>): boolean {
        return value === true || value === 1 || value === 'true';
    }

    public compareValues(left: SearchFilterValue | null | undefined, right: SearchFilterValue | null | undefined): boolean {
        if (left === null || left === undefined || right === null || right === undefined) {
            return left === right;
        }

        return String(left) === String(right);
    }

    private refreshViewModels(): void {
        this.viewModels = this.engine.getViewModels(this.selection);
    }
}
